export default {
    columns: [
        {
          type: "NUMERIC",
          desc: "Código interno del proyecto",
          label: "Código proyecto",
          field: "projectId"
        },
		{
          type: "CHARACTER",
          desc: "Nombre del proyecto",
          label: "Nombre proyecto",
          field: "shortName"
        },
		{
          type: "CHARACTER",
          desc: "Descripción del proyecto",
          label: "Desc. proyecto",
          field: "description"
        },
		{
          type: "CHARACTER",
          desc: "Referencia externa del proyecto",
          label: "Referencia proyecto",
          field: "projectReference"
        },
        {
          type: "SIMPLEDATE",
          desc: "wkt.admin.qbuilder.model.procedure.from-date.description",//"Fecha inicial indicada en la solicitud",
          label: "wkt.admin.qbuilder.model.procedure.from-date.text",//"Fecha inicial",
          field: "fromDate",
          formatter: "formatSimpleDate"
        },
        {
          type: "SIMPLEDATE",
          desc: "wkt.admin.qbuilder.model.procedure.to-date.description",//"Fecha final indicada en la solicitud",
          label: "wkt.admin.qbuilder.model.procedure.to-date.text",//"Fecha final",
          field: "toDate",
          formatter: "formatSimpleDate"
        },
        {
          field: "projectEnabled",
          type: "NUMERIC",
          desc: "Proyecto habilitado",
          label: "Proyecto habilitado",
          formatter: 'formatChoice',
          choices: [ { 'key':'0', 'value':'wkt.admin.common.no'/*'NO'*/ },
                     { 'key':'1', 'value':'wkt.admin.common.yes'/*'SI'*/ } ]
        },
		{
          type: "NUMERIC",
          desc: "Código interno del trabajador",
          label: "Código trabajador",
          field: "employeeId"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.firstname.description",//"Nombre",
          label: "wkt.admin.qbuilder.model.employee.firstname.text",//"Nombre",
          field: "firstname"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.lastname.description",//"Apellidos",
          label: "wkt.admin.qbuilder.model.employee.lastname.text",//"Apellidos",
          field: "lastname"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.id-number.description",//"Documento identificativo",
          label: "wkt.admin.qbuilder.model.employee.id-number.text",//"Documento ID",
          field: "idNumber"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.external-id.description",//"Referencia externa",
          label: "wkt.admin.qbuilder.model.employee.external-id.text",//"Referencia",
          field: "employeeReference"
        },
        {
          field: "username",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.username.description",//"Nombre de usuario",
          label: "wkt.admin.qbuilder.model.employee.username.text",//"Usuario"
        },
        {
          field: "workplaceId",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.employee.workplace-id.description",//"Código del centro de trabajo",
          label: "wkt.admin.qbuilder.model.employee.workplace-id.text",//"Código centro trabajo"
        },
        {
          field: "workplaceName",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.workplace-name.description",//"Nombre Centro de trabajo",
          label: "wkt.admin.qbuilder.model.employee.workplace-name.text",//"Centro trabajo"
        },
        {
          field: "departmentId",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.employee.department-id.description",//"Código del departamento",
          label: "wkt.admin.qbuilder.model.employee.department-id.text",//"Código departamento"
        },
        {
          field: "departmentName",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.department-name.description",//"Nombre Departamento",
          label: "wkt.admin.qbuilder.model.employee.department-name.text",//"Departamento"
        },
        {
          field: "supervisorId",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.employee.supervisor-id.description",//"ID Supervisor",
          label: "wkt.admin.qbuilder.model.employee.supervisor-id.text",//"ID Supervisor"
        },
        {
          field: "mobileNumberPrefix",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.mobile-number-prefix.description",//"Prefijo teléfnono móvil",
          label: "wkt.admin.qbuilder.model.employee.mobile-number-prefix.text",//"Prefijo móvil"
        },
        {
          field: "mobileNumber",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.mobile-number.description",//"Teléfnono móvil",
          label: "wkt.admin.qbuilder.model.employee.mobile-number.text",//"Móvil"
        },
        {
          field: "position",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.position.description",//"Puesto",
          label: "wkt.admin.qbuilder.model.employee.position.text",//"Puesto"
        },
        {
          field: "dedication",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.employee.dedication.description",//"Dedidación",
          label: "wkt.admin.qbuilder.model.employee.dedication.text",//"Dedidación",
        },
        {
          field: "employeeEnabled",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.employee.enabled.description",//"Habilitado",
          label: "wkt.admin.qbuilder.model.employee.enabled.text",//"Habilitado",
          formatter: 'formatChoice',
          choices: [ { 'key':'0', 'value':'wkt.admin.common.no'/*'NO'*/ },
                     { 'key':'1', 'value':'wkt.admin.common.yes'/*'SI'*/ } ]
        }
      ],
}